import React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import SettingsIcon from '@mui/icons-material/Settings';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PublishIcon from '@mui/icons-material/Publish';

import './index.scss';

interface StepperProps {
  steps: string[];
  activeStep: number;
  alternativeLabel?: boolean;
  className?: string;
}

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: '50%',
    left: 'calc(-50% + 120px)',
    right: 'calc(50% + 90px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg, #009688 0%, #26a69a 50%, #4db6ac 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg, #009688 0%, #26a69a 50%, #4db6ac 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 40,
  height: 40,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  '& svg': {
    fontSize: '30px',
  },
  ...(ownerState.active && {
    backgroundImage:
      'linear-gradient( 136deg, #009688 0%, #26a69a 50%, #4db6ac 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundImage:
      'linear-gradient( 136deg, #009688 0%, #26a69a 50%, #4db6ac 100%)',
  }),
}));

function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: <CloudUploadIcon style={{ fontSize: 20 }} />,
    2: <VisibilityIcon style={{ fontSize: 20 }} />,
    3: <PublishIcon style={{ fontSize: 20 }} />,
  };
  const Icon = icons[String(props.icon)];

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {Icon || <SettingsIcon />}
    </ColorlibStepIconRoot>
  );
}

const CustomizedStepper: React.FC<StepperProps> = ({
  steps,
  activeStep,
  alternativeLabel = true,
  className,
}) => {
  return (
    <Stack sx={{ width: '100%' }} spacing={4} className={`d-stepper ${className || ''}`}>
      <Stepper
        alternativeLabel={alternativeLabel}
        activeStep={activeStep}
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label} classes={{ root: 'step-root' }}>
            <StepLabel classes={{ root: 'step-label-root', labelContainer: 'step-label-container', label: 'step-label' }} StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
};

export default CustomizedStepper;
